define('translation/cs',{

  Project: 'Projekt',
  Subject: 'Předmět',
  Assignee: 'Přiřazeno',
  Status: 'Stav',
  Done: 'Hotovo',
  'Due date': 'Uzavřít do',
  'Updated on': 'Aktualizováno',
  'Assigned to': 'Přiřazeno',

  // Timey
  'Open Timey': 'Otevřít Timey',

  // Feedback
  'Send Feedback': 'Zpětná vazba',

  // Absences
  maybe: 'možná',
  'Show details': 'Zobrazit detaily',
  'Planned absences': 'Plánované nepřítomnosti',
  refresh: 'obnovit',
  'Not available from %0 to %1': 'Nedostupný od %0 do %1',
  'Not available %0': 'Nedostupný %0',

  // Assign select author
  'author': 'autor',

  // Issues
  'My issues': 'Mé úkoly',
  'No issues': 'Žádné úkoly',
  'Overdue issues': 'Úkoly s vypršeným Uzavřít do',
  'select random': 'zobrazit náhodný',
  'show all': 'zobrazit všechny',

  // Attachments
  'Add to editor': 'Přidat do editoru',

  // Last issue
  'Last viewed issue': 'Poslední zobrazený úkol',

  // Make money
  'I wanna work!': 'Chci práci!',

  // Issue
  'Due date is near.': 'Blíží se termín dokončení.',
  'Due date is over.': 'Vypršený termín dokončení.',
  'This issue has to be done': 'Tento úkol má být uzavřen',
  'This issue should be done': 'Tento úkol měl být uzavřen'
});

